export enum IframeMessageTypes {
  buttonClick = "buttonClick",
  inputFocus = "inputFocus",
  inputBlur = "inputBlur",
  formSubmitted = "formSubmitted",
  userActivity = "userActivity",
  setWindowClass = "setWindowClass",
  scanCompleted = "scanCompleted",
  scanCancelled = "scanCancelled",
  init = "init"
}

export interface ExternalCfsFeatureEvent {
  eventType: IframeMessageTypes;
  targetId: string;
}

export interface ExternalCfsFeatureMessageData {
  targetId: string;
  /** @deprecated: should be swapped to `targetId` */
  buttonId?: string;
  /** @deprecated: should be swapped to `targetId` */
  inputId?: string;
}

export interface IframeMessageData<T> {
  type: IframeMessageTypes;
  data: T;
}

export enum CarouselMessageTypes {
  resumeCarousel = "resumeCarousel",
  suspendCarousel = "suspendCarousel",
  resetCarousel = "resetCarousel"
}

export interface CarouselMessageData {
  type: CarouselMessageTypes;
}
